import {
  dateFormat,
  dateTimeFormat,
} from '../../../../../shared/constants/apiDateFormat';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { ScanMetadata } from '../../../../interfaces/scanMetadata';
import { CustomerInfo } from '../../../../pages/customer-profile/containers/NgzInbodyIndicatorsTab/NgzInbodyIndicatorsTab.settings';

type CustomerNameInfo = Pick<CustomerInfo, 'firstName' | 'lastName'>;

export const getInbodyResultFileName = (
  scansMetadata: ScanMetadata[],
  scanId: number,
  customer: CustomerNameInfo,
): string => {
  const scan = scansMetadata.find((item) => item.scanId === scanId);
  const fileNameDate = scan
    ? getFormattedDate(scan.scanDateTime, dateFormat, dateTimeFormat)
    : '';

  const customerName = [customer.firstName, customer.lastName]
    .filter(Boolean)
    .join('-')
    .replace(/[.\s]+/g, '-');

  return ['inbody-result', customerName, fileNameDate].filter(Boolean).join('-');
};
